<template>
  <div>
    <el-dialog
      :visible="true"
      width="800px"
      class="chartDia"
      :show-close="false"
      @close="close"
      v-loading="loading < 2"
    >
      <div slot="title" class="slotTit">{{ finalStatus | transPayStatus }}</div>
      <div v-if="finalStatus == 2" class="imgBox">
        <img src="@/assets/3.png" />
        <div class="imgLabel">支付中</div>
        <div class="imgDes">您的打款申请已提交，请耐心等待！</div>
      </div>
      <div v-else-if="finalStatus == 5" class="imgBox">
        <img src="@/assets/3.png" />
        <div class="imgLabel">支付中</div>
        <div class="imgDes">
          系统正在对订单进行支付，请耐心等待，终端到账时间为T+1天
        </div>
      </div>
      <div v-else-if="finalStatus == 6" class="imgBox">
        <img src="@/assets/2.png" />
        <div class="imgLabel">支付失败</div>
        <div class="imgDes">您的账户余额不足，本次支付失败，请重新提交支付</div>
      </div>
      <div v-else-if="finalStatus == 3" class="imgBox">
        <img src="@/assets/2.png" />
        <div class="imgLabel">支付失败</div>
        <div class="imgDes">本次支付失败，请重新提交支付</div>
      </div>
      <div v-else-if="finalStatus == 7" class="imgBox">
        <img src="@/assets/1.png" />
        <div class="imgLabel">支付成功</div>
      </div>
      <div class="flexBox">
        <div class="leftDiv">
          <b>订单编号：</b>
          {{ type != 2 ? table.orderNo : table.servicesOrderNo }}
        </div>
        <div class="rightDiv">
          <b>企业名称：</b>
          {{ table.enterpriseName }}
        </div>
      </div>
      <div class="flexBox borderBtm">
        <div class="leftDiv">
          <b>项目名称：</b>
          {{ table.projectName }}
        </div>
        <div class="rightDiv">
          <b>任务月度：</b>
          {{ table.taskDt }}
        </div>
      </div>
      <div
        style="text-align: right;font-size:14px;color:#333;font-weight:500;margin-bottom:20px;padding-right:5%"
      >
        到账时间
      </div>
      <template v-for="(item, index) in table.payDetail">
        <div
          class="flexBox"
          :key="index"
          style="align-items:baseline;border-bottom:1px solid #efefef;"
          v-if="[1, 3].includes(type)"
        >
          <div class="leftDiv">
            <b class="colorBf">供应商：</b>
            {{ item.supplieName }}
          </div>
          <div class="midDiv">
            <div>
              <label>银行账号：</label>
              {{ item.supplierBankNo }}
            </div>
            <div v-if="item.supplierBankName">
              <label>支行名称：</label>
              {{ item.supplierBankName }}
            </div>
            <div class="money">
              <label>项目结算金额：</label>
              {{ (table.orderPrice + table.discountPrice) | moneyFixed }}
            </div>
            <div class="money" v-if="table.discountPrice">
              <label>优惠：</label>
              {{ table.discountPrice | moneyFixed }}
            </div>
          </div>
          <div class="timeDiv">{{ table.finishPayDt | transAllTime }}</div>
        </div>
      </template>

      <div
        class="flexBox"
        style="align-items:baseline;border-bottom:1px solid #efefef;"
        v-if="[1, 2].includes(type)"
      >
        <div class="leftDiv">
          <b class="colorBf">平台：</b>
          {{ table.platformName }}
        </div>
        <div class="midDiv">
          <div>
            <label>银行账号：</label>
            {{ table.platformBankNo }}
          </div>
          <div v-if="table.supplierBankName">
            <label>支行名称：</label>
            {{ table.platformBankName }}
          </div>
          <div class="money">
            <label>平台服务费：</label>
            {{ table.platformServicesPrice | moneyFixed }}
          </div>
        </div>
        <div class="timeDiv">
          {{ table.servicesFinishPayDt | transAllTime }}
        </div>
      </div>
      <div style="text-align:right;margin-bottom:50px;" v-if="type == 1">
        项目金额：
        <b style="font-size:30px;">
          {{ (table.orderPrice + table.platformServicesPrice) | money }}
        </b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
      <div style="text-align:right;margin-bottom:50px;" v-else-if="type == 3">
        项目金额：
        <b style="font-size:30px;">{{ table.orderPrice | money }}</b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
      <div style="text-align:right;margin-bottom:50px;" v-else>
        项目金额：
        <b style="font-size:30px;">{{ table.platformServicesPrice | money }}</b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
      <div class="flexBox" style="justify-content:space-between;">
        <div style="display:flex;">
          <b class="colorBf" style="margin-right:40px;line-height:40px;">
            支付通道：
          </b>
          <el-select v-model="key" class="accountType">
            <el-option value="baofu" label="众邦银行"></el-option>
          </el-select>
        </div>
        <div v-loading="loadAccount" element-loading-spinner="el-icon-loading">
          余额：
          <b style="font-size:30px;">{{ info.balance | money }}</b>
          <i style="font-size:20px;font-style:normal">元</i>
        </div>
        <div v-if="finalStatus != 7 && finalStatus != 5" v-show="type != 2">
          预计支付金额：
          <b style="font-size:30px;color:#1989FA;">
            {{ table.leftOrderPrice | money }}
          </b>
          元
        </div>
      </div>
      <div
        class="hint"
        v-if="finalStatus == 1 || finalStatus == 4"
        style="color:#BFBFBF"
      >
        支付完成前，请保证账户内余额充足
      </div>
      <div
        class="hint"
        v-if="finalStatus == 1 || finalStatus == 4"
        style="color:#E90B0B"
      >
        届时请保证账户内余额充足。
      </div>
      <div
        class="flexBox"
        style="justify-content:center;margin-top:24px;"
        v-if="finalStatus == 1 || finalStatus == 4 || finalStatus == 6"
      >
        <el-button
          type="primary"
          style="margin-right:220px;"
          @click="check('sendMsg')"
          :disabled="checkIfPay()"
        >
          支付
        </el-button>
        <el-button
          style="border-radius:4px;border:2px solid rgba(25,137,250,1);color:#1989FA"
          @click="close"
        >
          返回
        </el-button>
      </div>
      <div v-else-if="finalStatus == 3 || finalStatus == 6">
        <el-button
          type="primary"
          @click="check('sendMsg')"
          :disabled="checkIfPay()"
        >
          重新支付
        </el-button>
      </div>
      <div
        v-else
        class="flexBox"
        style="justify-content:center;margin-top:24px;"
      >
        <el-button type="primary" @click="close">确认</el-button>
      </div>
    </el-dialog>
    <component :is="componentName" :type="type"></component>
  </div>
</template>
<script>
import sendMsg from './child/sendMsg.vue';
import payHistory from './child/payHistory.vue';
import deposit from './deposit.vue';
import { loadCsoOrder, bfAccount } from '@/api/ajax';
export default {
  inject: ['itemData'],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number
    }
  },
  data() {
    return {
      loading: 0,
      loadAccount: true,
      table: {
        payStatus: 0
      },
      info: {
        balance: ''
      },
      feiyongList: [
        { label: '合同签约费', key: 1 },
        { label: '实名认证费', key: 2 }
      ],
      showDetail: false,
      key: 'baofu',
      componentName: '',
      gysList: [
        {
          orderNo: '123124324235',
          companyName: '北京一样科技邮箱公司',
          time: '2019-08-27'
        },
        {
          orderNo: '123124321114235',
          companyName: '北京烧烤华盛顿科技邮箱公司',
          time: '2019-08-27'
        }
      ],
      finalStatus: 0
    };
  },
  methods: {
    close() {
      this.$parent.componentName = '';
    },
    check(componentName) {
      this.componentName = componentName;
    },
    checkIfPay() {
      if (this.type === 1) {
        //订单加服务费
        // return this.info.balance < (this.table.orderPrice + this.table.platformServicesPrice)
        return (this.info.balance || 0) < this.table.leftOrderPrice;
      } else if (this.type === 3) {
        //订单
        // return this.info.balance < this.table.orderPrice
        return (this.info.balance || 0) < this.table.leftOrderPrice;
      } else {
        //仅服务费
        return (this.info.balance || 0) < this.table.platformServicesPrice;
      }
    }
  },
  components: {
    sendMsg,
    payHistory,
    deposit
  },
  filters: {
    transPayStatus(v) {
      let s = {
        1: '待支付',
        2: '支付中',
        3: '支付失败',
        4: '继续支付',
        5: '支付中',
        6: '支付失败',
        7: '支付成功'
      };
      return s[v];
    }
  },
  async created() {
    try {
      bfAccount().then(res => {
        this.info = res.data.data;
        this.loading += 1;
        this.loadAccount = false;
      });
    } catch (error) {
      this.loading += 1;
    }
    let {
      data: { data }
    } = await loadCsoOrder({ csoOrderId: this.itemData.data.id });
    this.table = data;
    let ps = this.table.payStatus;
    let as = this.table.authStatus;
    let ss = this.table.servicesPricePayStatus;
    this.loading += 1;
    //1: '待支付',2: '审核中', 3: '审核未通过', 4: '部分支付成功',5: '支付中',6: '支付失败',7:'支付成功'
    if (this.type == 2) {
      let s = {
        0: 1,
        1: 5,
        2: 7,
        3: 6
      };
      this.finalStatus = s[ss];
    } else {
      if (ps == 0) {
        if (as == 0) {
          this.finalStatus = 1;
        } else if (as == 1) {
          this.finalStatus = 2;
        } else if (as == 3) {
          this.finalStatus = 3;
        } else if (as == 2) {
          this.finalStatus = 5;
        }
      } else if (ps == 1) {
        this.finalStatus = 5;
      } else if (ps == 2) {
        this.finalStatus = 4;
      } else if (ps == 4) {
        this.finalStatus = 6;
      } else if (ps == 3) {
        this.finalStatus = 7;
      }
    }
    // try {
    //   let data2 = await bfAccount();
    //   this.info = data2.data.data;
    //   this.loadAccount = false
    // } catch (error) { }
  }
};
</script>
<style lang="scss" scoped>
.flexBox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 26px;
  .leftDiv {
    width: 45%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 2%;
  }
  .rightDiv {
    width: 40%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .midDiv {
    width: 35%;
    text-align: left;
    display: flex;
    flex-direction: column;
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    label {
      width: 100px;
      text-align: right;
      color: #bfbfbf;
      font-size: 14px;
      line-height: 14px;
    }
    .money {
      color: #eb8e0e;
      label {
        color: #eb8e0e;
      }
    }
  }
  .timeDiv {
    width: 20%;
    text-align: center;
    font-weight: 400;
    color: #333;
  }
}
.colorBf {
  color: #bfbfbf;
}
.hint {
  color: #bfbfbf;
  font-size: 12px;
  margin-bottom: 16px;
}
.accountType {
  width: 138px;
}
.chargeBtn {
  width: 92px;
  height: 36px;
  background: rgba(235, 142, 14, 1);
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  padding: 0;
  margin-left: 20px;
}
.imgBox {
  img {
    width: 112px;
    height: 112px;
    margin-bottom: 20px;
  }
  .imgLabel {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .imgDes {
    color: #b4cfff;
    margin-bottom: 50px;
    font-size: 14px;
  }
}
.chartDia {
  .borderBtm {
    padding-bottom: 20px;
    border-bottom: 1px solid #efefef;
  }
}
</style>
